import { useFPGrowthStore } from '../dal/fp-growth-store';
import { calculateFPGrowth } from '../domain/fp-growth-provider';
import { round } from '../../../classifiers/decision-tree/domain/probability';

const FPGrowthView = () => {

    const params = useFPGrowthStore(store => store.params);

    const results = calculateFPGrowth(params);

    return (
        <div className="grid grid-cols-[auto_auto_auto] gap-6 items-start">
            <div>
                <div className="mb-4">
                    סף התמיכה = {  params.minSupport } * { params.rows.length } = { params.minSupport * params.rows.length }
                </div>

                <div className="border p-4 mb-4">
                    <p className="font-bold mb-2">האותיות שעברו את סף התמיכה:</p>
                    <div className="flex gap-4">
                        {
                            results.lettersMap.map(([letter, count], i) => {
                                return (
                                    <div key={ `letter-${i}` }>
                                        { letter } : { count }
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </div>

            <div>
                <p className="font-bold mb-2">Updated table:</p>
                <table className="mb-4">
                    <tbody>
                    {
                        results.cleanedTable.map((row, ri) => {
                            return (
                                <tr key={ `clean-table-${ ri }` }>
                                    <td className="border p-4">{ ri + 1 }</td>
                                    <td className="border p-4">
                                        { row.join(', ') }
                                    </td>
                                </tr>
                            )
                        })
                    }
                    </tbody>
                </table>
            </div>

            <div className="mb-4">
                <p className="font-bold mb-2">קבוצות תדירות:</p>
                <div className="grid grid-cols-1 border-t border-l border-r">
                    {
                        results.frequencyGroups.map((frequencyGroup, i) => {
                            return (
                                <div key={ `frequencyGroup-${ i }` } className="border-b px-4 py-2">
                                    { frequencyGroup }
                                </div>
                            )
                        })
                    }
                </div>
            </div>

            <svg width={ results.treeSvg.width } height={ results.treeSvg.height } viewBox={ `0 0 ${ results.treeSvg.width } ${ results.treeSvg.height }` }>
                {
                    results.treeSvg.nodes.map((node, i) => {
                        return (
                            <g key={ `node-${ i }` }>
                                <rect
                                    x={ node.x }
                                    y={ node.y }
                                    width={ node.width }
                                    height={ node.height }
                                    fill={ node.isRoot ? '#efefef' : '#fff' }
                                    stroke="#000"
                                />

                                {
                                    node.isRoot &&
                                    <text
                                        x={ node.x + 30 }
                                        y={ node.y + 40 }
                                        fontSize={ 16 }
                                    >{ '{  }' }</text>
                                }

                                {
                                    !node.isRoot &&
                                    <text
                                        x={ node.x + 35 }
                                        y={ node.y + 40 }
                                        fontSize={ 16 }
                                    >{ node.letter } : { node.count }</text>
                                }
                            </g>
                        )
                    })
                }

                {
                    results.treeSvg.lines.map((line, i) => {
                        return (
                            <g key={ `line-${ i }` }>
                                <line
                                    x1={ line.x1 }
                                    y1={ line.y1 }
                                    x2={ line.x2 }
                                    y2={ line.y2 }
                                    stroke={ '#535353' }
                                />
                            </g>
                        )
                    })
                }
            </svg>

            <div />
            <div />

            <table className="bg-white mb-10">
                <thead>
                <tr>
                    <td className="font-bold border px-4 py-2 text-center bg-slate-100">&nbsp;</td>
                    <th className="font-bold border px-4 py-2 text-center bg-slate-100">חוק הקשר</th>
                    <th className="font-bold border px-4 py-2 text-center bg-slate-100">confidence</th>
                    <th className="font-bold border px-4 py-2 text-center bg-slate-100">support</th>
                    <th className="font-bold border px-4 py-2 text-center bg-slate-100">חזק?</th>
                </tr>
                </thead>

                <tbody>
                {
                    results.associationRules.map((associationRule, i) => {
                        return (
                            <tr key={ `association-rule-${ i }` }>
                                <td className="border px-4 py-2 text-center bg-slate-100">{ i + 1 }</td>
                                <td className="border px-4 py-2 text-center">
                                    { associationRule.rule[0] } --&gt; { associationRule.rule[1] }
                                </td>
                                <td className="border px-4 py-2 text-center">
                                    { round(associationRule.confidence.topSupport.result) } / { round(associationRule.confidence.bottomSupport.result) } = { round(associationRule.confidence.result) }
                                </td>
                                <td className="border px-4 py-2 text-center">
                                    { round(associationRule.confidence.topSupport.result) }
                                </td>
                                <td className="border px-4 py-2 text-center">
                                    { associationRule.isStrong ? '✅' : '' }
                                </td>
                            </tr>
                        )
                    })
                }
                </tbody>
            </table>
        </div>
    )
};

export default FPGrowthView;